import { useEffect, useMemo, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import Layout from "./layout/index.jsx";

import { Login } from "../modules/identity-access/index.js";

import { ThemeProvider } from "@mui/material/styles";


import { ToastContainer } from "react-toastify";
import axiosInstance from "../shared/api/axiosInstance.js";
import { baseUrl, getStaticsData } from "../shared/api/endpoints.js";
import { setCompanyInfo } from "../shared/state/slices/relationals.js";
import { Gallery } from "../modules/media-content/index.js";
import { GalleryPickerProvider } from "../shared/ui/media/GalleryPicker.jsx";
import PanelRoutes from "./routes.jsx";
import { createPanelTheme } from "./theme.js";

const App = () => {
  const { token } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  useMemo(() => {
    document.body.setAttribute("dir", "rtl");
  }, []);
  const { themeColor } = useSelector((state) => state.themeColor);
  const dark = themeColor === "dark";
  const Theme = createPanelTheme(dark);
  useEffect(() => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      console.log("--------------------1 DEV MODE 2----------------------");
    } else {
      console.log(
        "--------------------3 PRODUCTION MODE 4----------------------"
      );
    }
  }, []);
  useLayoutEffect(() => {
    if (localStorage.getItem("fontSize")) {
      document.documentElement.style.fontSize = `${Number(
        localStorage.getItem("fontSize")
      )}px`;
    } else {
      document.documentElement.style.fontSize = `13px`;
    }
  }, [localStorage.getItem("fontSize")]);
  useEffect(() => {
    axiosInstance(`${baseUrl}/${getStaticsData}`)
      .then((res) => {
        const { data } = res;
        dispatch(setCompanyInfo(data?.data?.company));
      })
      .catch((err) => {});
  }, []);
  return (
    <GalleryPickerProvider component={Gallery}>
    <ThemeProvider theme={Theme}>
      <BrowserRouter>
        {!token ? (
          <>
            {" "}
            <Login />
          </>
        ) : (
          <>
            {/*      <h1 style={{textAlign:"center"}}>{sessionStorage.getItem("loaded")}</h1> */}
            <Layout>
              <PanelRoutes />
            </Layout>
          </>
        )}
        <ToastContainer
          position="top-right"
          hideProgressBar={false}
          closeOnClick={true}
          rtl={true}
          pauseOnFocusLoss={true}
          draggable={true}
          pauseOnHover={true}
        />
      </BrowserRouter>
    </ThemeProvider>
    </GalleryPickerProvider>
  );
};

export default App;
